import React, { Component } from "react";
import { Row, Col, Input, Table, Drawer, Button, Upload, message, Form, TreeSelect,  Select, Icon } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import { withRouter } from "react-router-dom";
import "./VendorList.css";
import SendMainIcon from "../../svg/svgicon/SendMailIcon";
import ButtonLinkIcon from "../../Components/MyComponent/ButtonLinkIcon";
import FilterIcon from "../../svg/svgicon/FilterIcon";
import { API } from "../../API/API";
import { baseConfig } from "../../Config/Config";
import VendorInfo from "./VendorInfo";
import getBase64 from "../../Components/ConvertBase64/getBase64";
import { map, includes, sortBy, uniqBy, each, result, get } from "lodash";

const Search = Input.Search;
const Option = Select.Option;

const isEmail = (email) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

class VendorList extends Component {
  state = {
    data: [],
    originalData: [],
    filteredData: [],
    filtered: false,
    filterFields: [],

    selectedVendorId: 0,
    vendor_cat_ids: [],
    selectedCategoryForSearch: "",
    vendorcategory_ids: [],
    searchNameText:"",
    searchPhoneText: "",

    sendButtonText: "И-мэйл илгээх (0)",
    selectedRowKeys: [],
    selectedVendors: [],
    subject: "",
    body: "",
    filename: "",
    filedata: null,
    filelist: [],
    emailNotSend: "",
    notSentCount: 0
     
  };
  componentDidMount = () => {
    this.getData();
    // this.getCategoryData();
  };
  //get list of vendors
  getData = () => {
    let vendordata =[];

    function search(nameKey, myArray){
      for (let i=0; i < myArray.length; i++) {
          if (myArray[i].id === nameKey) {
              return myArray[i].name;
          }
      }
    }
    API.get("getVendors").then((response) => {
      let vendorcats = [];
      let nextCounters = [];
      let tmp = [];
      if (response.status === 200) {
        vendordata = response.data.retData;
        
        API.post('/getVendorCategory', { url: baseConfig.makurl }).then((res) => {
          if (res.status === 200) {
              vendorcats = res.data.retData;
              this.setState({ vendorcategory_ids: vendorcats});       
              // format the category ; parent child appearance
              vendorcats.map((category, index) => {
                  if (category.parent_id === null) {
                    let formated_category = {
                        title: category.name,
                        value: category.id + '',
                        children: []
                    }
                    vendorcats.map((sub_category, sub_index) => {
                      if (sub_category.parent_id === category.id) {
                        formated_category.children.push({ title: sub_category.name, value: sub_category.id })
                      }
                    })
                    tmp.push(formated_category);
                  }
                })
                this.setState({vendor_cat_ids: tmp});
              //*********************
              // search by activity_id
              nextCounters = vendordata.map((c, i) => {
                if (c["activity_id"]!="" || c["activity_id"]!= null)
                  {
                    var separatedArray = c["activity_id"].split(',');
                    let resultObject=[];
                    if (separatedArray.length >0)
                      {
                        for(let x =0; x<separatedArray.length; x++)
                          {
                            resultObject.push(search(parseInt(separatedArray[x]), vendorcats));
                          }
                          c["activity"] = resultObject.join(" ");
                      }
                  }   
                  return c;
              });
              this.setState({ data: nextCounters});
              this.setState({ originalData: nextCounters});           
          }                  
        });        
      }
    });
  };
  // uil ajillagaanii chigleleer haih :
  SearchByCategoryHandleChange = (selectedCategoryValue) => {
    let a =this.state.vendorcategory_ids;
    let selectedText= "";
      for (let i = 0; i < a.length; i++) {
          let option = a[i];
          if (option['id'] == selectedCategoryValue) {
            selectedText = option['name'];
          }
      }
      this.setState({
        selectedCategoryForSearch: selectedCategoryValue,
        // selectedCategory: selectedCategoryValue 
      });
      let tTableData = []
      if (this.state.filtered === false)
        tTableData =[...this.state.originalData];
      else
        tTableData =[...this.state.data];

      if (selectedCategoryValue) {
        tTableData = tTableData.filter(r => {
          return (r.activity_id.includes(selectedCategoryValue));
        });  
        this.setState({filtered:true});       
      } else
      {
        this.setState({filtered:false});
      }  
    this.setState({ data: tTableData });  
  };
 
  onSearchByNameReg = e => {
    const searchText = e.target.value;
    const reg = new RegExp(e.target.value, "gi");
    if (searchText === "") {
      if (this.state.filtered === false) 
        this.setState({data: this.state.originalData});
      else
      this.setState({data: this.state.data});

    }
    else {
      const filteredData = map(this.state.data, record => {
        const nameMatch = get(record, "vendorname").match(reg);
        const regNumMatch = get(record, "registernumber").match(reg);
        const phoneNumMatch = get(record, "empphone").match(reg);
        const emailMatch = get(record, "vendoremail").match(reg);

        if (!nameMatch && !regNumMatch && !phoneNumMatch && !emailMatch) {
          return null
        }
        return record;
      }).filter(record => !!record);

      this.setState({
          searchText: e.target.value,
          data: filteredData
          // data: e.target.value ? filteredData : this.state.data   
      });
   }
  };

  clearAll = () => {
    this.setState({
        filteredData: null,
        sortedInfo: null,
        searchText: "",
        selectedCategoryForSearch: "",
        filtered: false,
        // selectedCategory: -1
    });
    this.getData();
  };
  //email ilgeeh hesgiin kod
  // email ilgeeheer songoh
  onSelectChange = (selectedRowKeys, record) => {
    if (selectedRowKeys.length > 0) {
      this.setState({
        selectedRowKeys: selectedRowKeys,
        sendButtonText: "И-мэйл илгээх (" + selectedRowKeys.length + ")",
        selectedVendors: [...record],
      });
    } else {
      this.setState({
        selectedRowKeys: selectedRowKeys,
        sendButtonText: "И-мэйл илгээх (" + selectedRowKeys.length + ")",
        selectedVendors: [],
      });
    }
  };
  fileOnChange = (info) => {
    this.setState({
      filelist: info.fileList,
      filedata: info.file,
      filename: info.file.name,
    });
  };
  sendEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;   
    if (this.state.selectedVendors.length > 0) {
      this.setState({emailNotSend:""})
      if (this.state.filename && this.state.filedata) {
        getBase64(this.state.filedata.originFileObj)
          .then((result) => {
            let filename = this.state.filename
              .split(".")
              .slice(0, -1)
              .join(".");
            let extension = this.state.filename.split(".").pop();
            let base64Data = result.split("base64,").pop();
            let vendors = [];
            let vendorsNotEmail = [];
            let str = "";
            let strNot = "";
            
            this.state.selectedVendors.map((el) => {
              if (el.vendoremail) {
                if (!isEmail(el.vendoremail)) {
                  vendorsNotEmail = [...vendorsNotEmail, el.vendorname];
                } else {
                  vendors = [...vendors, el.vendoremail];
                }
              } else 
                  vendorsNotEmail = [...vendorsNotEmail, el.vendorname];
            });
            str = vendors.join(",");
            strNot = vendorsNotEmail.join(", ");
             let varNotSentCount = vendorsNotEmail.length
            this.setState({emailNotSend:strNot})
            this.setState({notSentCount: vendorsNotEmail.length})

            
            // let body = {
            //   vendors: vendors,
            //   attachmentFile: {
            //     filename: filename,
            //     extension: extension,
            //     data: base64Data,
            //   },
            //   body: this.state.body,
            //   subject: this.state.subject,
            //   url: baseConfig.makurl,
            //   session_id: localStorage.getItem("access_token"),
            // };
            let body = {
              To: str,
              Subject: this.state.subject,
              Content: this.state.body,

              attachmentFile: {
                filename: filename,
                extension: extension,
                data: base64Data,
              },              
            };
            API.post("sendEmail", body).then((response) => {
              if (response.status === 200 && response.data.retType === 0) {
                message.success("Амжилттай илгээгдлээ.");
                message.warning("{} нийлүүлэгчдийн Имэйл хаяг буруу/хоосон учраас имэйл илгээгдээгүй", strNot + " - " + varNotSentCount);
                
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        message.warning("Файл хавсаргана уу.");
      }
    } else {
      message.warning("Нийлүүлэгч сонгоно уу.");
    }
  };
  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
       [name]: value
    });
  }
  // email ilgeeh hesgiin kod -END
  
  
  // open edit/detail info of selected vendor
  showNewInputFormHandler = (show, vendorid) => {
    this.setState({
      showNewInputForm: show,
      selectedVendorId: vendorid,
    });
  };

  render() {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    const columns = [
      {
        title: "Нэр",
        dataIndex: "vendorname",
        key: "vendorname",
        width: "10%",
        align: "left",
        filteredValue: filteredInfo.name || null,
        onFilter: (value, record) => record.vendorname.includes(value),
        render: (text, record) => {
          return (
            <Button
              className="link"
              type="link"
              onClick={() =>
                this.showNewInputFormHandler(true, record.vendorid)
              }
            >
              {record.vendorname}
            </Button>
          );
        },
      },
      {
        title: "Регистр",
        dataIndex: "registernumber",
        key: "registernumber",
        width: "5%",
        align: "left",
      },
      {
        title: "Төрөл",
        dataIndex: "vendortypeid",
        key: "vendortypeid",
        width: "5%",
        align: "left",
        render: (text, record) => {
          return (
            <div>
              {record.vendortypeid === 1
                ? "ААН"
                : record.vendortypeid === 2
                ? "Хувь хүн"
                : "Гадаад"}
            </div>
          );
        },
      },
      {
        title: "Үйл ажиллагааны чиглэл",
        dataIndex: "activity",
        key: "activity",
        width: "15%",
        align: "left",
      },
      {
        title: "Ү.а чиглэл-хуучин",
        dataIndex: "activityOld",
        key: "activityOld",
        width: "15%",
        align: "left",
      },
      {
        title: "Компаний статус",
        dataIndex: "vendorstatusid",

        key: "vendorstatusid",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <div>{record.vendortypeid === 1 ? "Идэвхитэй" : "Идэвхигүй"}</div>
          );
        },
      },
      {
        title: "Утасны дугаар",
        dataIndex: "empphone",
        key: "empphone",
        width: "7%",
        align: "left",
      },
      {
        title: "Байгууллагын и-мэйл",
        dataIndex: "vendoremail",
        key: "vendoremail",
        width: "12%",
        align: "left",
      },
      {
        title: "Бүртгэсэн огноо",
        dataIndex: "created",
        key: "created",
        width: "10%",
        align: "left",
      },
      {
        title: "Ажилтан",
        dataIndex: "empname",
        key: "empname",
        width: "10%",
        align: "left",
      },
     
    ];
   
    const { searchText } = this.state;
    const suffix = searchText ? (
      <Button onClick={this.emitEmpty} />
    ) : null;

    const { selectedRowKeys } = this.state;
    const rowSelection = {
      columnWidth: 40,
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return (
      <div className="Container">
        <Row style={{ height: 56 }} justify="start" align="middle">
          <Col>
            <div className="HeaderLabel">Нийлүүлэгчийн жагсаалт</div>
          </Col>
          <Col>
            <div className="divider"></div>
          </Col>         
        </Row>
        <Row gutter={[16, 16]} style={{ marginBottom: 10 }} className="table-row-dark">
          <Col span={4}>
            <div className="Label">Гарчиг</div>
            <Input
              style={{ height: 30, width: "100%" }}
              size="large"
              defaultValue={this.state.subject}
              name = "subject"
              onChange={(e) => this.handleInputChange(e)}
            />
          </Col>
          <Col span={8}>
            <div className="Label">Тайлбар</div>
            <Input
              style={{ height: 30, width: "100%" }}
              size="large"
              defaultValue={this.state.body}
              name = "body"
              onChange={(e) => this.handleInputChange(e)}
            />
          </Col>
          <Col span={2}>
            <div className="Label">Файл хавсаргах</div>
            <Upload
              style={{ width: "100%" }}
              accept="*"
              openFileDialogOnClick
              onChange={this.fileOnChange}
              showUploadList={false}
              fileList={this.state.filelist}
            >
              <Button style={{ color: "black", borderColor: "#cecece" }}>
                <Row align="middle" justify="space-between">
                  <Col>{this.state.filename}</Col>
                  <Col style={{ marginLeft: 10, marginRight: 10 }}>
                    <UploadOutlined />
                  </Col>
                </Row>
              </Button>
            </Upload>
          </Col>
          <Col span={4}>
            <div className="Label">&nbsp;&nbsp;</div>
            <ButtonLinkIcon
              icon={<SendMainIcon />}
              name={this.state.sendButtonText}
              onClick={() => {
                this.sendEmail();
              }}
            />
          </Col>
 
        </Row>
        { (this.state.emailNotSend) ? 
        <Row className="table-row-red"><Col>{ this.state.notSentCount} нийлүүлэгчийн Имэйл хайг буруу/хоосон учир имэйл илгээгдээгүй: { this.state.emailNotSend}</Col></Row>
          : ""   
        }
        <div id="vendor-list" style={{ marginRight: 15 }}>
        <div className="table-operations">
        <Row style={{ height: 56 }} justify="start" align="left">
         <Col span={5}>
            <Search
              ref={ele => (this.searchText = ele)}
              suffix={suffix}
              name= "searchText"
              onChange={this.onSearchByNameReg}
              placeholder="Нэр/регистр/имэйл/утасны дугаар/-р хайх"
              value={this.state.searchText}
              onPressEnter={this.onSearchByNameReg}
            />
          </Col>
          <Col span={4}>
          <TreeSelect
            showSearch
            style={{width: '100%',}}
            value={this.state.selectedCategoryForSearch}
            dropdownStyle={{maxHeight: 400, overflow: 'auto',}}
            placeholder="Үйл ажиллагааны чиглэл сонгох..."
            onChange={this.SearchByCategoryHandleChange}
            treeDefaultExpandAll  
            treeData={this.state.vendor_cat_ids}
          /> 
          </Col>
         {/* <Col>
              <Button type="default"
                style={{fontWeight: 600,fontSize: 14,color: "#212121",borderRadius: 2,}}
                onClick={this.SearchByActivity}>Хайх
              </Button>
          </Col> */}
          <Col>
          <Button onClick={this.clearAll}>Clear Search</Button>
          </Col>
        </Row>            
        </div>
          <Table
            dataSource={this.state.data}
            rowSelection={{ ...rowSelection, columnWidth: "2%" }}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            pagination={false}
            rowKey="vendorid"
            scroll={{ y: 600 }}
          />
        </div>
        <Drawer
          title="Нийлүүлэгчийн дэлгэрэнгүй"
          width="1100px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0)}
          destroyOnClose={true}
        >
          <VendorInfo
            vendorid={this.state.selectedVendorId}
            showForm={this.showNewInputFormHandler}
          ></VendorInfo>
        </Drawer>
      </div>
    );
  }
}

export default withRouter(VendorList);
